<script>
  import {getContext} from 'svelte';
  import {PRIZE_COIN_NAME} from '../const';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');

  const tradePrizeData = [
    ['', '1', '2', '3', '4-6', '7-10'],
    ['< 250', 3000, 1500, 800, 500, 200],
    ['250-500', 5000, 3000, 1500, 800, 300],
    ['>500', 8000, 5000, 2000, 1000, 500],
  ];
  const tradePrizeDataH5 = transposeArray2D(tradePrizeData);

  function transposeArray2D(array2D) {
    const rowCount = array2D.length;
    const columnCount = array2D[0].length;
    const ret = [];
    for (let i = 0; i < columnCount; i++) {
      const row = [];
      for (let j = 0; j < rowCount; j++) {
        row.push(array2D[j][i]);
      }
      ret.push(row);
    }
    return ret;
  }
</script>

<style>
  .price-structure {
    font-size: 14px;
    color: #fff;
    font-weight: 500;
  }
  .data-row {
    display: flex;
    border-bottom: 1px solid #192434;
  }
  .data-td {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid #192434;
    height: 60px;
    background: #0d131b;
  }
  .data-row:first-child {
    border-top: 1px solid #192434;
  }
  .data-td:first-child {
    border-left: 1px solid #192434;
  }
  .data-td:nth-child(even) {
    background: #080d16;
  }
  .structure-data {
    padding-bottom: 40px;
  }
  .structure-data:last-child {
    padding-bottom: 0;
  }
  @media screen and (min-width: 640px) {
    .show-in-pc {
      display: block;
    }
    .show-in-h5 {
      display: none;
    }
  }
  @media screen and (max-width: 640px) {
    .show-in-pc {
      display: none;
    }
    .show-in-h5 {
      display: block;
    }
  }
</style>

<div class="price-structure">
  <div class="structure-data show-in-pc">
    {#each tradePrizeData as row, i}
      <div class="data-row">
        {#each row as content, j}
          {#if !i && !j}
            <div class="data-td">{LG(lang.Rank)}/{LG(lang.Participants)}</div>
          {:else}
            <div class="data-td">{content} {i > 0 && j > 0 ? PRIZE_COIN_NAME : ''}</div>
          {/if}
        {/each}
      </div>
    {/each}
  </div>
  <div class="structure-data show-in-h5">
    {#each tradePrizeDataH5 as row, i}
      <div class="data-row">
        {#each row as content, j}
          {#if !i && !j}
            <div class="data-td">
              {LG(lang.Participants)}<br />
              /{LG(lang.Rank)}
            </div>
          {:else}
            <div class="data-td">{content} {i > 0 && j > 0 ? PRIZE_COIN_NAME : ''}</div>
          {/if}
        {/each}
      </div>
    {/each}
  </div>
</div>
